<template>
  <div class="order">
    <loading v-if="isLoadingState"></loading>
    <div class="order-one mui-bar-nav" id="searchBar">
      <p class="order-one-p">账目</p>
      <div class="order-one-two">
        <div class="order-one-two-left">
          <p class="left-p">待结算金额</p>
          <p class="left-twoP">
            ¥
            <span class="left-span">{{
              totalToBeSettleAmount.toLocaleString()
            }}</span>
          </p>
        </div>
        <div class="order-one-two-right" @click="onclickClose">
          <span>一键结算</span>
        </div>
      </div>
      <div class="order-one-three">
        <div class="order-one-three-span">
          <p>待退回(元)</p>
          <p>{{ totalRefundAmount.toLocaleString() }}</p>
        </div>
        <div class="order-one-three-span order-one-three-Twospan">
          <p>结算中(元)</p>
          <p>{{ totalSettlingAmount.toLocaleString() }}</p>
        </div>
        <div class="order-one-three-span" style="margin-left: 20px">
          <p>累计结算(元)</p>
          <p>{{ totalSettleAmount.toLocaleString() }}</p>
        </div>
      </div>
    </div>
    <div class="order-two">
      <van-sticky @scroll="vanStickyScroll">
        <div v-if="offsetTopState" class="home-header-fixed header">账目</div>
      </van-sticky>
      <van-tabs
        ref="getheight"
        v-model="status"
        @change="change"
        swipeable
        sticky
        @click="onclickHighlight"
      >
        <van-tab
          v-for="(item, index) in wholeList"
          :key="index + '+only'"
          :title="item.name"
        >
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              @load="onLoadList"
              v-model="isUpLoading"
              :finished="finished"
              :immediate-check="false"
              :finished-text="finishedText"
            >
              <div v-for="isitem in shopList" :key="isitem.id">
                <div class="order-two-one" @click="onClickShop(isitem)">
                  <div class="order-two-two">
                    <div class="order-two-two-left">
                      <span>订单号：{{ isitem.serialNumber }}</span>
                    </div>
                    <div class="order-two-two-right">
                      <span
                        :class="
                          isitem.statusName == '已取消' ||
                          isitem.statusName == '待退款' ||
                          isitem.statusName == '已退款' ||
                          isitem.statusName == '退款中'
                            ? 'aaa'
                            : isitem.statusName == '已完成'
                            ? 'bbb'
                            : 'ccc'
                        "
                        >{{ isitem.statusName }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="completerecords-two"
                    v-for="(items, index) in isitem.paymentGoodsList"
                    :key="index"
                  >
                    <div class="completerecords-two-left">
                      <img :src="items.productNormsImg" alt />
                    </div>
                    <div class="completerecords-two-right">
                      <div class="completerecords-two-right-one">
                        <span>{{ ellipsis || items.productName }}</span>
                        <span>(货号：{{ items.artNo }})</span>
                      </div>
                      <p>
                        <span class="right-one-span">
                          {{ items.productNormsName }}
                        </span>
                      </p>
                      <div class="completerecords-two-right-two">
                        <p>
                          ￥
                          <span class="completerecords-onespan">{{
                            items.costPrice
                          }}</span>
                          <span class="completerecords-twospan"
                            >x{{ items.number }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="completerecords-three"
                    v-if="
                      isitem.statusName == '待结算' ||
                      isitem.statusName == '待退款'
                    "
                  >
                    <div class="completerecords-three-left">
                      <span>
                        {{
                          isitem.status == "1" ? "待结算金额" : "待退款金额"
                        }}￥
                      </span>
                      <span>{{ isitem.totalAmount }}</span>
                    </div>
                    <div
                      class="completerecords-three-right"
                      @click="onclickAccount(isitem, index)"
                    >
                      <span>{{ isitem.status == "1" ? "结算" : "退款" }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="imgState">
                <div class="imgState" style="text-align: center; height: 65vh">
                  <img src="../../assets/imgage/youhuiquan_blank.png" alt />
                  <p>您还没有账户明细哦</p>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <!--一键结算  -->
    <div v-if="CloseState" class="order-footer">
      <vSettleAccounts
        :token="token"
        :settleObj="settleObj"
        @onclickImg="onclickImg"
        @onClickSumbit="onClickSumbit"
      />
    </div>
  </div>
</template>
<script>
import {
  getSupplier,
  getSupplierDisposable,
  getSupplierpage,
  getSupplierApply,
} from "api/index/api";
import { Toast } from "vant";
import Loading from "base/loading/loading";
import vSettleAccounts from "./orderForm/settleAccounts"; // 一键结算

export default {
  components: {
    Loading,
    vSettleAccounts,
  },
  data() {
    return {
      // offsetTop: "8.639rem",
      isLoadingState: true,
      pageIndex: 0, //页码
      pagesize: 10, // 每页条数
      isLoading: false, //控制下拉刷新的加载动画
      finished: false, // 上拉加载完毕
      isUpLoading: false, // 上拉加载
      totalToBeSettleAmount: 0, //待结算总额
      totalRefundAmount: 0, //待退回总金额
      totalSettlingAmount: 0, //结算中总金额
      totalSettleAmount: 0, //累计结算总金额
      offsetTopState: false,
      finishedText: null, //没数据提示样式
      ellipsis: null, //显示多少字符
      status: 0, //售后状态类型
      token: "", //登陆信息
      settleObj: {}, //一键结算数据
      CloseState: false, // 一键结算状态
      imgState: false, //购物车为空状态
      //订单商品
      shopList: [],
      // title
      wholeList: [
        { id: "0", name: "全部" },
        { id: "1", name: "待结算" },
        { id: "2", name: "结算中" },
        { id: "3", name: "已结算" },
        { id: "4", name: "已完成" },
        { id: "5", name: "待退款" },
        { id: "6", name: "退款中" },
        { id: "7", name: "已退款" },
        { id: "8", name: "已取消" },
      ],
      // 状态类型
      statusObj: {
        1: "待结算",
        2: "结算中",
        3: "已结算",
        4: "已完成",
        5: "待退款",
        6: "退款中",
        7: "已退款",
        8: "已取消",
      },
    };
  },
  mounted() {
    this.onGetSupplier();
    this.onRequestList();
    let getuserInfo = JSON.parse(localStorage.getItem("access_token"));
    this.token = getuserInfo;
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    // this.$nextTick(() => {
    //   this.offsetTop = "45px";
    // });
  },
  created() {
    let getStatus = JSON.parse(localStorage.getItem("status"));
    this.status = Number(getStatus);
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  methods: {
    beforeunloadHandler(e) {
      localStorage.removeItem("status");
    },
    // 下拉显示账目
    vanStickyScroll(event) {
      if (event.isFixed) {
        this.offsetTopState = true;
      } else {
        this.offsetTopState = false;
      }
    },
    // 结算中/已结算/已完成/已取消/退款中/已退款
    onClickShop(e) {
      localStorage.setItem("status", JSON.stringify(e.status));
      if (
        e.status == 2 ||
        e.status == 4 ||
        e.status == 6 ||
        e.status == 7 ||
        e.status == 8 ||
        e.status == 3 ||
        this.status == 3 ||
        this.status == 2 ||
        this.status == 4 ||
        this.status == 6 ||
        this.status == 7 ||
        this.status == 8
      ) {
        this.$router.push({
          path: "/complete/records",
          query: {
            // id: this.status || e.status,
            // commodityName: e,
            serialNumber: e.serialNumber,
            sellerId: e.sellerId,
            status: e.status,
          },
        });
      }
    },
    // 待结算/待退回
    onclickAccount(e, value) {
      localStorage.setItem("status", JSON.stringify(e.status));
      if (
        this.status == 1 ||
        this.status == 5 ||
        e.status == 1 ||
        e.status == 5
      ) {
        this.$router.push({
          path: "/sunRefund",
          query: {
            // id: this.status || e.status,
            // commodityName: e,
            serialNumber: e.serialNumber,
            sellerId: e.sellerId,
            status: e.status,
          },
        });
      }
    },
    // 限制title显示字数
    controlTextList(value) {
      value.forEach((item, index) => {
        item.paymentGoodsList.forEach((e, index) => {
          if (e.productName.length > 17) {
            // 限制字数17个字
            this.ellipsis = e.productName.slice(0, 20) + "...";
          } else {
            this.ellipsis = e.productName.slice(0, 20);
          }
        });
      });
    },
    //  提交结算申请
    onClickSumbit() {
      let params = {
        Authorization: this.token,
      };
      getSupplierApply(params).then((res) => {
        Toast.success("提交成功");
        this.onGetSupplier();
        this.onRequestList();
        this.CloseState = false;
      });
    },
    // 首页List
    onRequestList() {
      const _this = this;
      let params = {
        status: this.status,
        pageNum: this.pageIndex,
        pageSize: this.pagesize,
      };
      this.isLoading = true;
      getSupplierpage(params)
        .then((res) => {
          this.isLoading = false; //加载完毕。。。
          if (res) {
            this.controlTextList(res.list);
            res.list.map((item) => {
              let totalAmountF = Math.round(item.totalAmount * 100) / 100;
              let totalAmountS = totalAmountF.toString();
              let totalAmountFS = totalAmountS.indexOf(".");
              if (totalAmountFS < 0) {
                totalAmountFS = totalAmountS.length;
                totalAmountS += ".";
              }
              while (totalAmountS.length <= totalAmountFS + 2) {
                totalAmountS += "0";
              }
              this.totalAmount = totalAmountS;
            });
            let resData = res.list.map((item) => ({
              ...item,
              statusName: this.statusObj[item.status],
            }));

            if (resData.length < this.pagesize) {
              // 最后一页不足10条的情况
              _this.finished = true;
            } else {
              _this.finished = false;
            }
            if (this.pageIndex == 1) {
              _this.shopList = [...resData];
            } else {
              _this.shopList = [..._this.shopList, ...resData];
            }
            if (_this.shopList.length == 0) {
              this.imgState = true;
              _this.finishedText = "";
            } else {
              this.imgState = false;
              _this.finishedText = "我是有底线的";
            }
          }
        })
        .catch((error) => {
          // this.$message({
          //   showClose: true,
          //   message: '获取资源列表异常{' + error + '}',
          //   type: 'error'
          // })
        })
        .finally(() => {
          _this.isLoading = false;
          _this.isUpLoading = false;
        });
    },
    // 获取账目统计
    onGetSupplier() {
      let getuserInfo = JSON.parse(localStorage.getItem("access_token"));
      let params = {
        Authorization: getuserInfo,
      };
      getSupplier(params).then((res) => {
        if (res) {
          this.isLoadingState = false;
          let resData = res;
          let str1 = resData.totalToBeSettleAmount.toString();
          let reg1 =
            str1.indexOf(".") > -1
              ? /(\d)(?=(\d{3})+\.)/g
              : /(\d)(?=(?:\d{3})+$)/g;
          let val1 = str1.replace(reg1, "$1,");
          this.totalToBeSettleAmount = val1;
          // 结算中
          let str = resData.totalSettlingAmount.toString();
          let reg =
            str.indexOf(".") > -1
              ? /(\d)(?=(\d{3})+\.)/g
              : /(\d)(?=(?:\d{3})+$)/g;
          let val = str.replace(reg, "$1,");
          this.totalSettlingAmount = val;
          // 累计结算
          let str2 = resData.totalSettleAmount.toString();
          let reg2 =
            str2.indexOf(".") > -1
              ? /(\d)(?=(\d{3})+\.)/g
              : /(\d)(?=(?:\d{3})+$)/g;
          let val2 = str2.replace(reg2, "$1,");
          this.totalSettleAmount = val2;
          // 待退回
          let str3 = resData.totalRefundAmount.toString();
          let reg3 =
            str3.indexOf(".") > -1
              ? /(\d)(?=(\d{3})+\.)/g
              : /(\d)(?=(?:\d{3})+$)/g;
          let val3 = str3.replace(reg3, "$1,");
          this.totalRefundAmount = val3;
        } else {
          this.isLoadingState = true;
        }
      });
    },
    // 下拉刷新
    onRefresh: function () {
      this.shopList = [];
      this.finished = false;
      this.pageIndex = 1;
      this.onGetSupplier();
      this.onRequestList();
    },
    //上拉加载
    onLoadList() {
      if (this.isLoading == false && this.finished == false) {
        this.pageIndex++;
        this.onRequestList();
      }
    },
    //滑动
    change(index, item) {
      this.status = index;
      this.shopList = [];
      this.pageIndex = 1;
      this.finished = false;
      this.isLoading = true; //清空数据
      this.onGetSupplier();
      this.onRequestList();
    },
    //点击
    onclickHighlight(index, item) {
      this.status = index;
      this.shopList = [];
      this.pageIndex = 1;
      this.finished = false;
      this.isLoading = true; //清空数据
      this.onGetSupplier();
      this.onRequestList();
    },
    // 关闭一键结算弹窗
    onclickImg() {
      this.CloseState = false;
      var mo = function (e) {
        e.stopImmediatePropagation();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    //一键结算
    getrDisposable() {
      let params = {
        Authorization: this.token,
      };
      getSupplierDisposable(params).then((res) => {
        if (res) {
          this.settleObj = res;
        }
      });
    },
    // 一键结算操作
    onclickClose() {
      this.CloseState = true;
      this.getrDisposable();
      var mo = function (e) {
        e.stopImmediatePropagation();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.mui-bar-nav {
  -webkit-transition: all 0.28s ease-in 0.1s;
  transition: all 0.28s ease-in 0.1s;
}
.header {
  -webkit-transition: all 0.28s ease-in 0.1s;
  transition: all 0.28s ease-in 0.1s;
}
.home-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  bottom: 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
  line-height: 100px;
  text-align: center;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.order {
  background: #f6f7fb;
  height: 100vh;
  overflow-y: scroll;
  .order-one {
    padding: 47px 0 0 0;
    width: 100%;
    background: linear-gradient(137deg, #ff855a 0%, #e84031 100%);
    text-align: center;
    .order-one-p {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .order-one-two {
      padding: 0 30px 45px 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // padding-bottom: 45px;
      .order-one-two-left {
        text-align: left;
      }
      .left-p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff8f7;
      }
      .left-twoP {
        margin-top: 6px;
        font-size: 24px;
        font-family: ArialMT;
        color: #ffffff;
      }
      .left-span {
        font-size: 48px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #ffffff;
      }
      .order-one-two-right {
        padding: 10px 20px 9px 20px;
        background: #ffffff;
        border-radius: 28px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e84031;
      }
    }
    .order-one-three {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 0 30px;
      border-top: 1px solid #fb836f;
      .order-one-three-span {
        padding: 21px 0 20px 0;
        display: flex;
        flex: 1;
        flex-direction: column;
        text-align: left;
        & > p:nth-child(1) {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff8f7;
          line-height: 33px;
        }
        & > p:nth-child(2) {
          margin-top: 9px;
          font-size: 28px;
          font-family: Arial-BoldMT, Arial;
          font-weight: normal;
          color: #ffffff;
          line-height: 32px;
        }
      }
      .order-one-three-Twospan {
        border-left: 1px solid #fb836f;
        border-right: 1px solid #fb836f;
        padding-left: 20px;
      }
      .order-one-three-Threespan {
        margin-left: 20px;
      }
    }
  }
  .order-two {
    // height: 100%;
    .order-two-two {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .order-two-two-left {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .order-two-two-right {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #e84031;
    }
    .completerecords-two {
      padding: 30px 0 30px 0;
      display: flex;
      background: #ffffff;
    }
    .completerecords-two-left {
      width: 170px;
      height: 170px;
    }
    .completerecords-two-left img {
      width: 170px;
      height: 170px;
    }
    .completerecords-two-right {
      margin-left: 32px;
      width: 100%;
      .completerecords-two-right-one {
        position: relative;
        & > span:nth-child(2) {
          position: absolute;
          right: 15px;
          top: 40px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 36px;
        }
      }
      .completerecords-two-right-one span:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 72px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 36px;
      }

      .completerecords-two-right-two {
        margin-top: 21px;
        & > p:nth-child(1) {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        .completerecords-onespan {
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .completerecords-twospan {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #c7c7c7;
        }
      }
    }
    .completerecords-two-right p:nth-child(2) {
      // padding: 0 13px 0 8px;

      border-radius: 6px;
      margin-top: 11px;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 30px;
      // width: 110px;
      .right-one-span {
        display: inline-block;
        background: #f6f6f6;
        padding: 0 13px 0 8px;
      }
    }
    .completerecords-three {
      display: flex;
      justify-content: flex-end;
      padding: 36px 0 24px 0;
      align-items: center;
      .completerecords-three-left span:nth-child(1) {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: inline-block;
        vertical-align: middle;
      }
      .completerecords-three-left span:nth-child(2) {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        display: inline-block;
        vertical-align: middle;
      }
      .completerecords-three-right {
        margin-left: 10px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        background: #e84031;
        padding: 11px 34px;
        border-radius: 30px;
      }
    }
  }
  .order-two-one {
    padding: 20px 24px;
    width: 95%;
    margin: 0 auto;
    margin-top: 21px;
    background: #ffffff;
    border-radius: 16px;
  }

  .bbb {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .aaa {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff910c;
  }
  .ccc {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #e84031;
  }
  .imgState {
    & > img {
      margin-top: 250px;
      width: 440px;
      height: 258px;
    }
    & > p {
      margin-top: 30px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/completeRecords/order.vue